import { GetOnlineAccountResponse } from '@iwoca/lapi-client/edge';

export type OpenBankingStatus =
    'disconnected' | 'expired' | 'expiring' | 'connected';

type OnlineAccount = GetOnlineAccountResponse['data'][number];

export const OB_EXPIRY_THRESHOLD_DAYS = 14;

export const getOpenBankingStatus = (
    onlineAccounts: OnlineAccount[],
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    expiryThresholdDays: number = OB_EXPIRY_THRESHOLD_DAYS
): OpenBankingStatus => {
    const relevantAccounts = onlineAccounts.filter(
        (account) => account.status.code !== 'connecting'
    );

    if (relevantAccounts.length === 0) {
        return 'disconnected';
    }

    const hasActive = relevantAccounts.some(
        (account) => account.status.code === 'active'
    );

    if (hasActive) {
        return 'connected';
    }

    const hasExpired = relevantAccounts.some(
        (account) => account.status.code === 'expired'
    );

    if (hasExpired) {
        return 'expired';
    }

    // The "expiring" state is intentionally suppressed for now.
    //
    // It is computed purely from `expiry_at` against a threshold, but updating
    // an account does not currently refresh `expiry_at` on the backend, so a
    // customer who re-links sees no change and the warning is misleading.
    // Until the backend refreshes the connection period on update, we collapse
    // "expiring" into "connected". The computation below is preserved so this
    // can be re-enabled with a one-line change once the backend supports it.
    //
    // To re-enable: uncomment the block below and return 'expiring'.
    //
    // const now = Date.now();
    // const thresholdMs = expiryThresholdDays * 24 * 60 * 60 * 1000;
    //
    // const hasExpiring = relevantAccounts.some((account) => {
    //     if (!account.expiry_at) return false;
    //     const timeUntilExpiry = new Date(account.expiry_at).getTime() - now;
    //     return timeUntilExpiry > 0 && timeUntilExpiry <= thresholdMs;
    // });
    //
    // if (hasExpiring) {
    //     return 'expiring';
    // }

    return 'disconnected';
};
